module.exports = __webpack_public_path__ + "img/20230313_pause_user_create.7f4d9c30.png";